import type { ProjectServiceConfig } from '@customink/project-service-react-components';

export const config: ProjectServiceConfig = {
  accountsServiceUrl: import.meta.env.PROJECT_SERVICE_ACCOUNTS_SERVICE_URL,
  catalogUrl: import.meta.env.PROJECT_SERVICE_CATALOG_URL,
  coreOrderUrl: import.meta.env.PROJECT_SERVICE_CORE_ORDER_CART_URL,
  ciHostname: import.meta.env.PROJECT_SERVICE_CI_HOSTNAME,
  designsUrl: import.meta.env.PROJECT_SERVICE_DESIGNS_URL,
  imagesUrl: import.meta.env.PROJECT_SERVICE_IMAGES_URL,
  inventoriesUrl: import.meta.env.PROJECT_SERVICE_INVENTORIES_URL,
  inventoriesApiUrl: import.meta.env.PROJECT_SERVICE_INVENTORIES_API_URL,
  internalCheckoutUrl: import.meta.env.PROJECT_SERVICE_INTERNAL_CHECKOUT_URL,
  labProxyUrl: import.meta.env.PROJECT_SERVICE_LAB_PROXY_URL,
  locationsUrl: import.meta.env.PROJECT_SERVICE_LOCATIONS_URL,
  pricesUrl: import.meta.env.PROJECT_SERVICE_PRICES_URL,
  productsUrl: import.meta.env.PROJECT_SERVICE_PRODUCTS_URL,
  profilesUrl: import.meta.env.PROJECT_SERVICE_PROFILES_URL,
  projectsUrl: import.meta.env.PROJECT_SERVICE_URL,
  quotesUrl: import.meta.env.PROJECT_SERVICE_QUOTES_URL,
  sizesUrl: import.meta.env.PROJECT_SERVICE_SIZES_URL,
  sizingUrl: import.meta.env.PROJECT_SERVICE_SIZING_URL,
  appVersion: import.meta.env.APP_VERSION,
  klaviyoPublicApiKey: import.meta.env.PROJECT_SERVICE_KLAVIYO_PUBLIC_API_KEY,
};
